// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OWxTM","right":"styles_right__1FmmL"};